exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .yHcwEkufwomHbdsqnVxvZ{padding:15px}", ""]);
// Exports
exports.locals = {
	"inspectorWrapper": "yHcwEkufwomHbdsqnVxvZ"
};